import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const BUSINESS_TYPES_BUSINESS_TYPE_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/business-types',
        name: '::Menu:BusinessTypes',
        iconClass: 'fas fa-briefcase',
        layout: eLayoutType.application,
        requiredPolicy: 'ReturnLy.BusinessTypes',
        parentName: '::Menu:Configurations',
        order: 5,
      },
    ]);
  };
}
